import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import e from "react";
function t(e, t) {
  var a = [],
    n = (t === null || t === void 0 ? void 0 : t.serviceName) || null;
  e && e.length > 0 && e.forEach(function (e) {
    e.relevantExternalPage && a.push(e.relevantExternalPage);
  });
  var r = [];
  return void 0 !== n && a.length > 0 && (r = {
    "@type": "Thing",
    name: n,
    sameAs: a
  }), r;
}
var a = function a(_ref) {
  var a = _ref.businessType,
    n = _ref.blogPageUrl,
    r = _ref.aboutPageUrl,
    i = _ref.contactPageUrl,
    o = _ref.articleBody,
    s = _ref.videos,
    l = _ref.siteUrl,
    d = _ref.questionsAndAnswers,
    p = _ref.maps,
    c = _ref.digitalDocuments,
    u = _ref.images,
    g = _ref.categories,
    m = _ref.tags,
    y = _ref.uri,
    h = _ref.businessName,
    v = _ref.title,
    P = _ref.post,
    S = _ref.datePublished,
    f = _ref.dateModified,
    b = _ref.image,
    A = _ref.author,
    w = _ref.logo,
    C = _ref.areaServedGeneral,
    $ = _ref.areaServedPageSpecific,
    x = _ref.serviceGeneral,
    E = _ref.servicePageSpecific,
    N = _ref.keywords,
    O = _ref.localAwards,
    _ = _ref.latitude,
    j = _ref.longitude,
    T = _ref.relevantExternalPages,
    U = _ref.phoneNumber,
    I = _ref.streetAddress,
    L = _ref.city,
    M = _ref.state,
    k = _ref.zipCode;
  var B = o ? o.replace(/(<([^>]+)>)/gi, "") : "",
    D = B ? B.split(" ").length : 0,
    H = s ? function (e, t) {
      return e.map(function (e) {
        return {
          "@type": "VideoObject",
          name: e.title,
          url: e.url,
          description: e.description,
          thumbnailUrl: "".concat(t).concat(e.thumbnailImage),
          uploadDate: e.uploadDate
        };
      });
    }(s, l) : [],
    J = d ? function (e) {
      return {
        "@type": "FAQPage",
        mainEntity: e.map(function (e) {
          return {
            "@type": "Question",
            name: e.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: (t = e.answer, t.replace(/<\/?[^>]+(>|$)/g, " ").replace(/["”]/g, "'").replace(/[\n\r]/g, "").replace(/\s+/g, " ").trim())
            }
          };
          var t;
        })
      };
    }(d) : {},
    z = c ? function (e) {
      return e.map(function (e) {
        return {
          "@type": "DigitalDocument",
          name: e.title
        };
      });
    }(c) : [],
    G = u ? function (e, t) {
      return e.map(function (e) {
        return {
          "@type": "ImageObject",
          contentUrl: "".concat(t).concat(e.image),
          datePublished: e.date,
          description: e.description,
          name: e.title
        };
      });
    }(u, l) : [],
    R = function (e, a, n) {
      return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "".concat(e),
        about: t(a, n)
      };
    }(h, T, E),
    q = function (e, t) {
      return null !== e ? [{
        "@type": "City",
        name: e
      }] : t.map(function (e) {
        return {
          "@type": "City",
          name: e.city
        };
      });
    }($, C),
    F = function (e, t, a, n, r, i, o, s, l) {
      return null !== (e === null || e === void 0 ? void 0 : e.serviceName) ? [{
        "@type": "Service",
        serviceType: e === null || e === void 0 ? void 0 : e.serviceName,
        provider: {
          "@type": "Organization",
          name: a,
          telephone: r,
          address: {
            "@type": "PostalAddress",
            streetAddress: i,
            addressLocality: o,
            addressRegion: s,
            postalCode: l,
            addressCountry: "US"
          },
          "@id": n
        },
        url: e === null || e === void 0 ? void 0 : e.relevantPage
      }] : t.map(function (e) {
        return {
          "@type": "Service",
          serviceType: e === null || e === void 0 ? void 0 : e.serviceName,
          provider: {
            "@type": "Organization",
            name: a,
            telephone: r,
            address: {
              "@type": "PostalAddress",
              streetAddress: i,
              addressLocality: o,
              addressRegion: s,
              postalCode: l,
              addressCountry: "US"
            },
            "@id": n
          },
          url: e === null || e === void 0 ? void 0 : e.relevantPage
        };
      });
    }(E, x, h, l, U, I, L, M, k),
    Q = function (e, t, a, n, r, i, o, s, l, d, p, c, u) {
      var g = {
        "@type": e,
        name: s,
        telephone: l,
        address: {
          "@type": "PostalAddress",
          streetAddress: d,
          addressLocality: p,
          addressRegion: c,
          postalCode: u,
          addressCountry: "US"
        },
        hasMap: t === null || t === void 0 ? void 0 : t.map(function (e) {
          return e.url;
        }),
        areaServed: a,
        keywords: i === null || i === void 0 ? void 0 : i.map(function (e) {
          return e.keyword;
        }),
        knowsAbout: i === null || i === void 0 ? void 0 : i.map(function (e) {
          return e.keyword;
        }),
        award: o === null || o === void 0 ? void 0 : o.map(function (e) {
          return e.localAward;
        })
      };
      return n && r && (g.geo = {
        "@type": "GeoCoordinates",
        latitude: n,
        longitude: r
      }), g;
    }(a, p, q, _, j, N, O, h, U, I, L, M, k),
    V = [].concat(_toConsumableArray((g === null || g === void 0 ? void 0 : g.length) > 0 ? g.map(function (e) {
      return e.name;
    }) : []), _toConsumableArray((m === null || m === void 0 ? void 0 : m.length) > 0 ? m.map(function (e) {
      return e.name;
    }) : [])).join(", ");
  return e.createElement(e.Fragment, null, n === y || n === l + y ? e.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Blog",
        name: "".concat(h, " Blog")
      }, null, 2)
    }
  }) : null, r === y || r === l + y ? e.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "AboutPage",
        about: h,
        name: v
      }, null, 2)
    }
  }) : null, i === y || i === l + y ? e.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "ContactPage",
        description: "".concat(h, " contact page"),
        name: v,
        potentialAction: "Contact ".concat(h),
        url: i
      }, null, 2)
    }
  }) : null, !0 === P ? e.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "BlogPosting",
        "@id": "".concat(l).concat(y),
        headline: v,
        datePublished: S,
        dateModified: f,
        image: b,
        author: A,
        publisher: {
          "@type": "Organization",
          name: h,
          logo: {
            "@type": "ImageObject",
            url: "".concat(l).concat(w)
          }
        },
        articleSection: V,
        articleBody: B,
        wordCount: D
      }, null, 2)
    }
  }) : null, e.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "http://www.schema.org",
        "@graph": [Q, R].concat(_toConsumableArray(H), [J], _toConsumableArray(z), _toConsumableArray(G), _toConsumableArray(F))
      }, null, 2)
    }
  }));
};
export { a as PageSpecificSchema };